/**
 * AdminBanner
 *
 * Persistent banner shown at the top of the layout when an admin is
 * viewing another user's workspaces/data.  Provides an "Exit" button
 * to return to the admin's own workspaces.
 */
import { useAdminMode } from '@/hooks/useAdminMode'
import { useNavigate } from 'react-router-dom'
import { useQueryClient } from '@tanstack/react-query'
import { ShieldCheckIcon, XMarkIcon } from '@heroicons/react/20/solid'

export function AdminBanner() {
  const { isAdminMode, targetUserId, targetUserLabel, exitAdminMode } = useAdminMode()
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  if (!isAdminMode) return null

  const handleExit = () => {
    exitAdminMode()
    // Invalidate workspace query so own workspaces reload
    queryClient.invalidateQueries({ queryKey: ['workspaces'] })
    navigate('/')
  }

  return (
    <div className="bg-amber-500 text-black px-4 py-1.5 flex items-center justify-center gap-3 text-sm font-medium z-50 relative">
      <ShieldCheckIcon className="w-4 h-4 flex-shrink-0" />
      <span className="truncate">
        Admin Mode — viewing user{' '}
        <span className="font-semibold">{targetUserLabel || targetUserId}</span>
      </span>
      <button
        onClick={handleExit}
        className="inline-flex items-center gap-1 ml-2 px-2 py-0.5 rounded bg-black/10 hover:bg-black/20 transition-colors text-xs font-semibold flex-shrink-0"
      >
        <XMarkIcon className="w-3.5 h-3.5" />
        Exit
      </button>
    </div>
  )
}
